import { createFetchContext } from '../contextFetch/FetchContext';
export default createFetchContext();